<template>
    <div>
        
        <!-- 面積 -->
        <div class="block-text-sm">
            <i :class="$tools.style.classIcon('area', 'block-text')"></i>
            <div class="block-text">{{ $t('menu.' + i18nArea) }}:</div>

            <div v-if="computed_area" class="block-text">

                <!-- 面積：單選按鈕 -->
                <div v-if="selectorType == 'radio'">

                    <b-form-radio-group v-model="selected_unit">

                        <div class="area-value">{{ computed_area.toFixed(2) }}</div>

                        <b-form-radio v-for="(unit, idx_u) in units" :key="idx_u + '-area-r'" :value="unit" class="radio-unit">
                            <span v-html="$t( 'u.' + unit )"></span>
                        </b-form-radio>

                    </b-form-radio-group>

                </div>
                <!-- 面積：下拉式選單 -->
                <div v-else>

                    <div class="area-value">{{ computed_area.toFixed(2) }}</div>

                    <b-form-select v-model="selected_unit" class="select-unit">
                        <option v-for="(unit, idx_u) in units" :key="idx_u + '-area-d'" :value="unit" class="radio-unit">
                            <span v-html="$t( 'u.' + unit )"></span>
                        </option>
                    </b-form-select>

                </div>
                    
            </div>
            <!-- 面積：未輸入 -->
            <div v-else class="block-text">
                ---
            </div>
        </div>


        <!-- 單位密度 -->
        <div v-if="showDensity" class="block-text-sm">

            <i :class="$tools.style.classIcon('area', 'block-text')"></i>
            <div class="block-text">{{ $t('menu.planting_density') }}:</div>

            <div v-if="computed_density" class="block-text">

                <!-- 單位密度：單選按鈕 -->
                <div v-if="selectorType == 'radio'">

                    <b-form-radio-group v-model="selected_unit">

                        <div class="area-value">{{ computed_density.toFixed(2) }}</div>

                        <b-form-radio v-for="(unit, idx_u) in units" :key="idx_u + '-density-r'" :value="unit" class="radio-unit">
                            <span v-html="$t('n.plants') + '/' + $t( 'u.' + unit )"></span>
                        </b-form-radio>

                    </b-form-radio-group>

                </div>
                <!-- 單位密度：下拉式選單 -->
                <div v-else>

                    <div class="area-value">{{ computed_density.toFixed(2) }}</div>

                    <b-form-select v-model="selected_unit" class="select-unit-density">
                        <option v-for="(unit, idx_u) in units" :key="idx_u + '-density-d'" :value="unit" class="radio-unit">
                            <span v-html="$t('n.plants') + '/' + $t( 'u.' + unit )"></span>
                        </option>
                    </b-form-select>

                </div>

            </div>
            <!-- 單位密度：未輸入 -->
            <div v-else class="block-text">
                ---
            </div>

        </div>

    </div>
</template>

<script>
export default {
    props: {
        pageType: {
            type: String,
            default: 'project',
        },
        area: {
            type: Number,
        },
        density: {
            type: Number,
        },
        defaultUnit: {
            type: String,
            default: 'm2',
        },
        timezone: {
            type: String,
            default: 'Asia/Taipei'
        },
        selectorType: {
            type: String,
            default: 'dropdown'
        },
    },
    data () {
        return {
            i18nArea: 'field_area',
            showDensity: false,

            units: this.$tools.unit.area_units.default, //[ 'm2', 'ha', 'acre' ],
            selected_unit: 'm2',
            computed_area: undefined,
            computed_density: undefined,
        }
    },
    mounted () {

        this.setPageInfo();

        if (this.timezone == 'Asia/Taipei') { this.units = this.$tools.unit.area_units.taiwan; } //[ 'm2', 'ha', 'hun', 'kah', 'acre' ]; }

        if (this.area)    { this.computed_area = this.area; }
        if (this.density) { this.computed_density = this.density; }

        this.selected_unit = this.defaultUnit;

    },
    watch:
    {

        selected_unit (val, oldVal)
        {
            if (oldVal && val)
            {
                this.computed_area = this.$tools.unit.area_unit_convert( oldVal, val, this.computed_area );
                this.computed_density = this.$tools.unit.density_unit_convert( oldVal, val, this.computed_density );
            }
        },

    },
    methods: {

        setPageInfo ()
        {
            this.showDensity = false;
            switch (this.pageType)
            {
                case 'project':     this.i18nArea = 'project_area'; break;
                case 'cropperiod':  this.i18nArea = 'field_area'; this.showDensity = true; break;
                default:            this.i18nArea = 'project_area'; break;
            }
        },

    },
}
</script>


<style lang="scss" scoped>

.area-value
{
    display: inline-block;
    margin-right: 10px;
    font-size: 1.1rem;
}

.radio-unit
{
    display: inline-block;
    margin-right: 15px;
    font-size: 0.9rem;
}

.select-unit
{
    display: inline-block;
    width: 80px;
    padding-left: 2px;
}
.select-unit-density
{
    display: inline-block;
    width: 110px;
    padding-left: 2px;
}

</style>

